var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7867 1.4401C16.8544 1.37249 16.908 1.29222 16.9446 1.20389C16.9812 1.11555 17 1.02087 17 0.925251C17 0.829635 16.9812 0.734955 16.9446 0.646617C16.908 0.558278 16.8544 0.478012 16.7867 0.410401C16.7191 0.34279 16.6389 0.289158 16.5505 0.252568C16.4622 0.215977 16.3675 0.197144 16.2719 0.197144C16.1763 0.197144 16.0816 0.215977 15.9933 0.252568C15.9049 0.289158 15.8247 0.34279 15.757 0.410401L9 7.1689L2.24296 0.410401C2.17535 0.34279 2.09508 0.289158 2.00674 0.252568C1.9184 0.215977 1.82372 0.197144 1.72811 0.197144C1.63249 0.197144 1.53781 0.215977 1.44947 0.252568C1.36113 0.289158 1.28087 0.34279 1.21326 0.410401C1.14565 0.478012 1.09201 0.558278 1.05542 0.646617C1.01883 0.734955 1 0.829635 1 0.925251C1 1.02087 1.01883 1.11555 1.05542 1.20389C1.09201 1.29222 1.14565 1.37249 1.21326 1.4401L7.97175 8.19714L1.21326 14.9542C1.07671 15.0907 1 15.2759 1 15.469C1 15.6621 1.07671 15.8473 1.21326 15.9839C1.3498 16.1204 1.535 16.1971 1.72811 16.1971C1.92121 16.1971 2.10641 16.1204 2.24296 15.9839L9 9.22539L15.757 15.9839C15.8936 16.1204 16.0788 16.1971 16.2719 16.1971C16.465 16.1971 16.6502 16.1204 16.7867 15.9839C16.9233 15.8473 17 15.6621 17 15.469C17 15.2759 16.9233 15.0907 16.7867 14.9542L10.0282 8.19714L16.7867 1.4401Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCrossIcon);
export default __webpack_public_path__ + "static/media/popup-cross-icon.871548ddda27eb4b57eea71ad2c7bd64.svg";
export { ForwardRef as ReactComponent };